/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import { AuthenticationService } from "./authentication.service";
import { BaseService } from "./base-service";
import { PagedResults } from "app/models/paged-results";
import { RestService } from "./rest-service";
import { Url_Base } from "app/rest-constants";
import { GtinValidationSetHeader } from "app/models/gtin-validation-set-header";
import { GtinValidationSetDetail } from "app/models/gtin-validation-set-detail";
import { GtinValidationSetDto  } from "app/models/gtin-validation-set.dto";

/**
 * Service used to interact with the GTIN Validation Set backend.
 */
@Injectable()
export class GtinValidationSetService extends BaseService {

  /** Constructor */
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService
  ) {
    super(router, authenticationService);
  }

  /**
   * Returns the base URL for the GTIN Validation Set backend.
   */
  private getUrl(): string {
    return `${Url_Base}/validation-set/gtins/`;
  }

  /**
   * Returns a page of GTIN Validation Set Header information based on the given information.
   */
  getGtinValidationSetHeaders(start: number, size: number, order: String, filterString: String): Promise<PagedResults<GtinValidationSetHeader>> {
    const callUrl = `${this.getUrl()}paging?start=${start}&size=${size}&order=ASC&filterColumn=name&filterString=${filterString}`;
    return this.mRestService.get<PagedResults<GtinValidationSetHeader>>(callUrl);
  }

  /**
   * Returns a page of GTIN Validation Set Detail information based on the given information.
   */
  getGtinValidationSetdetails(start: number,size: number, order: String, filterColumn: String,filterString: String,name: String): Promise<PagedResults<GtinValidationSetDetail>> {
    const callUrl = `${this.getUrl()}viewset/`+name+`/paging?start=${start}&size=${size}&order=ASC&filterColumn=${filterColumn}&filterString=${filterString}`;
    return this.mRestService.get<PagedResults<GtinValidationSetDetail>>(callUrl);
  }
  

  /**
   * Used to upload a CSV File containing GTIN Validation Set information to 
   * be saved by the backend.
   */
  uploadGtinValidationSet(formData: FormData): Promise<void> {
    const callUrl = this.getUrl();
    return this.mRestService.upload(callUrl, formData);
  }


  deleteValidationSets(ids: number[]): Promise<any> {
    console.log("ids"+ids);
    const callUrl = this.getUrl();
    return this.mRestService.delete(callUrl, ids);
  }

  deleteValidationDetailSets(id: number): Promise<any> {
    console.log("id"+id);
    const callUrl = `${this.getUrl()}details/`+id;
    return this.mRestService.delete(callUrl, id);
  }

  /*createDetailSet(gtinDetails: GtinValidationSetDetail): Promise<GtinValidationSetDetail> {
    const callUrl = `${this.getUrl()}saveDetails`;
    return this.mRestService.post<GtinValidationSetDetail>(callUrl, gtinDetails);
  }*/

  createDetailSet(dto: GtinValidationSetDto): Promise<GtinValidationSetDto> {
    const callUrl = `${this.getUrl()}details`;
      console.log("dto",dto)
    return this.mRestService.post<GtinValidationSetDto>(callUrl, dto);
  }

  updateDetailSet(gtinDetails: GtinValidationSetDetail): Promise<GtinValidationSetDetail> {
    const callUrl = `${this.getUrl()}details`;
    return this.mRestService.put<GtinValidationSetDetail>(callUrl, gtinDetails);
  }

  createHeaderSet(formData: FormData): Promise<void> {
    const callUrl = `${this.getUrl()}header`;
    return this.mRestService.upload(callUrl, formData);
  }

 

}
